export {
  getSessionId,
  getDeviceId,
  identify,
  Identify,
  init,
  revenue,
  Revenue,
  add,
  setDeviceId,
  setOptOut,
  setSessionId,
  setUserId,
  track,
  Types,
} from '@amplitude/analytics-browser';
